module.exports = __webpack_public_path__ + "static/media/settings_your-profile.f0fe5d76.svg";